import { z } from 'zod';
import { emailSchema, optionalText } from '../common.js';

/** Landing-page capture. Public endpoint, rate-limited, no JWT. */
export const waitlistSignupSchema = z.object({
  email: emailSchema,
  name: optionalText,
  weddingDate: z.string().max(20).optional(),
  source: z.string().max(60).optional(),
  /** Honeypot: bots fill it, humans never see it. Must be empty. */
  company: z.string().max(0).optional(),
});
export type WaitlistSignupInput = z.infer<typeof waitlistSignupSchema>;
